export const GET_PROPOSAL_LIST = 'GET_PROPOSAL_LIST';
export const GET_PROPOSAL_LIST_REQUEST = 'GET_PROPOSAL_LIST_REQUEST';
export const GET_PROPOSAL_LIST_SUCCESS = 'GET_PROPOSAL_LIST_SUCCESS';
export const GET_PROPOSAL_LIST_FAILURE = 'GET_PROPOSAL_LIST_FAILURE';
export const GET_PROPOSAL_PREVIEW_REQUEST = 'GET_PROPOSAL_PREVIEW_REQUEST';
export const GET_PROPOSAL_PREVIEW_SUCCESS = 'GET_PROPOSAL_PREVIEW_SUCCESS';
export const GET_PROPOSAL_PREVIEW_FAILURE = 'GET_PROPOSAL_PREVIEW_FAILURE';
export const GET_PROPOSAL_PREVIEW = 'GET_PROPOSAL_PREVIEW';
export const TOGGLE_PROPOSAL_LIST_DRAWER = 'TOGGLE_PROPOSAL_LIST_DRAWER';

export const CREATE_PROPOSAL = 'CREATE_PROPOSAL';
export const CREATE_PROPOSAL_REQUEST = 'CREATE_PROPOSAL_REQUEST';
export const CREATE_PROPOSAL_SUCCESS = 'CREATE_PROPOSAL_SUCCESS';
export const CREATE_PROPOSAL_FAILURE = 'CREATE_PROPOSAL_FAILURE';

export const DELETE_PROPOSAL = 'DELETE_PROPOSAL';
export const DELETE_PROPOSAL_REQUEST = 'DELETE_PROPOSAL_REQUEST';
export const DELETE_PROPOSAL_SUCCESS = 'DELETE_PROPOSAL_SUCCESS';
export const DELETE_PROPOSAL_FAILURE = 'DELETE_PROPOSAL_FAILURE';

export const COPY_PROPOSAL = 'COPY_PROPOSAL';
export const COPY_PROPOSAL_REQUEST = 'COPY_PROPOSAL_REQUEST';
export const COPY_PROPOSAL_SUCCESS = 'COPY_PROPOSAL_SUCCESS';
export const COPY_PROPOSAL_FAILURE = 'COPY_PROPOSAL_FAILURE';

export const SET_IS_PRIMARY_PROPOSAL = 'SET_IS_PRIMARY_PROPOSAL';
export const UPDATE_PROPOSAL_REQUEST = 'UPDATE_PROPOSAL_REQUEST';
export const UPDATE_PROPOSAL_SUCCESS = 'UPDATE_PROPOSAL_SUCCESS';
export const UPDATE_PROPOSAL_FAILURE = 'UPDATE_PROPOSAL_FAILURE';
export const UPDATE_PROPOSAL = 'UPDATE_PROPOSAL';

export const GET_PROPOSAL = 'GET_PROPOSAL';
export const GET_PROPOSAL_REQUEST = 'GET_PROPOSAL_REQUEST';
export const GET_PROPOSAL_SUCCESS = 'GET_PROPOSAL_SUCCESS';
export const GET_PROPOSAL_FAILURE = 'GET_PROPOSAL_FAILURE';

// Analytics-only (no reducer): drive CDL v3 Pixall tags for the Print Proposal payment grid checkboxes.
export const PAYMENT_GRID_DOWN_PAYMENT_CHECKBOX_CLICKED = 'PAYMENT_GRID_DOWN_PAYMENT_CHECKBOX_CLICKED'; // dc-mv-323
export const PAYMENT_GRID_TERM_CHECKBOX_CLICKED = 'PAYMENT_GRID_TERM_CHECKBOX_CLICKED'; // dc-mv-324
